import { Module } from 'vuex';
import { ManagerStateStorable, manager } from './managerPagesStore';
import { ClientStateStorable, client } from './clientPagesStore';

// Función para persistir el estado de pages en localStorage
const persistPagesState = (state, pages) => {
  state.manager = pages.manager;
  state.client = pages.client;
  localStorage.setItem('pagesStore', JSON.stringify(pages));
};

// Estado inicial por defecto para pagesStore
const Pages = {
  defaulInitState: () => ({
    manager: {
      teamRequests: {
        filters: {
          status: undefined,
          company: undefined,
          search: undefined
        }
      },
      stemdoers: {
        filters: {
          status: undefined,
          vertical: undefined,
          search: undefined
        }
      },
      projects: {
        filters: {
          company: undefined,
          search: undefined
        }
      }
    },
    client: {
      teamRequests: {
        filters: {
          status: undefined
        }
      }
    }
  })
};

export interface PagesStateStorable {
  manager: ManagerStateStorable;
  client: ClientStateStorable;
}

export const pagesStore: Module<PagesStateStorable, any> = {
  namespaced: true,
  modules: {
    manager,
    client
  },
  mutations: {
    clearToInitState(state) {
      persistPagesState(state, Pages.defaulInitState());
    }
  }
};
